import React from "react";
import Modal from "@ui-kit/modal/fullscreen";
import TemplateLibrary from "@radarly/components/panels/wizard/template-library";
import { useWizardLibrary } from "@radarly/core/wizard/use-cases";
import { Workspace } from "@radarly/models/workspace";
import { IRouterService } from "@radarly/shared/router";

export default function WizardTemplateLibrary({
  router,
  workspaceId,
}: {
  router: IRouterService;
  workspaceId: Workspace["id"];
}) {
  const { templates, emptyTemplate, title, templatesTitle, onClose } =
    useWizardLibrary({
      router,
      workspaceId,
    });
  return (
    <Modal title={title} onClose={onClose}>
      <TemplateLibrary
        templates={templates}
        emptyTemplate={emptyTemplate}
        title={templatesTitle}
        onClick={onClose}
      />
    </Modal>
  );
}
